import React, { lazy, Suspense, useContext } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { ChangeEmailContext } from "context/ChangeEmailContext";

const ChangeEmailForm = lazy(() => import("components/ProfileChangeEmail/Screens/ChangeEmailForm"));
const ChangeEmailConfirmation = lazy(() => import("components/ProfileChangeEmail/Screens/ChangeEmailConfirmation"));
const ChangeEmailFinish = lazy(() => import("components/ProfileChangeEmail/Screens/ChangeEmailFinish"));
const ChangeEmailValidate = lazy(() => import("components/ProfileChangeEmail/Screens/ChangeEmailValidate"));

export const DEFAULT_SCREENS = {
    FORM: "form",
    VALIDATE: "validate",
    CONFIRMATION: "confirmation",
    FINISH: "finish",
};

const ProfileChangeEmailDialogScreens = React.memo(() => {
    const { activeScreen } = useContext(ChangeEmailContext);

    if (!activeScreen) return null;
    return (
        <Suspense
            fallback={
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <CircularProgress sx={{ color: "#A61F38" }} size={20} />
                </Box>
            }>
            <div style={{ display: activeScreen === DEFAULT_SCREENS.FORM ? "block" : "none" }}>
                <ChangeEmailForm />
            </div>
            {activeScreen === DEFAULT_SCREENS.VALIDATE && <ChangeEmailValidate />}
            {activeScreen === DEFAULT_SCREENS.CONFIRMATION && <ChangeEmailConfirmation />}
            {activeScreen === DEFAULT_SCREENS.FINISH && <ChangeEmailFinish />}
        </Suspense>
    );
});

export default ProfileChangeEmailDialogScreens;
